// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DD-b","largestCol":"styles_largestCol__320kU","smallestCol":"styles_smallestCol__2ZIQQ"};